import { render, staticRenderFns } from "./ToDashboard.vue?vue&type=template&id=3311d63c&"
import script from "./ToDashboard.vue?vue&type=script&lang=js&"
export * from "./ToDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports